module.exports = __webpack_public_path__ + "img/energy.1b04f904.png";